import "./App.css";
import Header from "./Header";
import Footer from "./Footer";
import conceptImage from "./assets/idea.svg";
import offerImage from "./assets/offer.svg";
import aboutImage from "./assets/aboutus.svg";
import aboutUsImage from "./assets/2Z2A0643.jpg";
import galleryImage1 from "./assets/2Z2A0647.jpg";
import galleryImage2 from "./assets/2Z2A0598.jpg";
import galleryImage3 from "./assets/2Z2A0626.jpg";
import galleryImage4 from "./assets/2Z2A0631.jpg";
import galleryImage5 from "./assets/2Z2A0648.jpg";
import galleryImage6 from "./assets/2Z2A0650.jpg";
import galleryImage7 from "./assets/2Z2A0660.jpg";
import contactImage from "./assets/mail.svg";
import flowImage from "./assets/Flow_chart_mit_Foto.png";
import { Link, Routes, Route} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { useIsMobile } from "./useIsMobile";
import { Cross as Hamburger } from 'hamburger-react';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery-bundle.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

function App() {
  const [activeTab, setActiveTab] = useState("home");
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [showMobileMenu , setShowMobileMenu] = useState(false);
  const menuRef = useRef(null);
  
  useEffect(() => {
    if (!showMobileMenu) return;

    function handleClickOutside(event) {

      if (showMobileMenu === true && menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMobileMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMobileMenu]);

  return (
    <div className="app">
      { isMobile ? (
        <header>
        <div className="header-content" ref={menuRef}>
          <Hamburger toggled={showMobileMenu} toggle={setShowMobileMenu} />
          <div className={`left ${showMobileMenu ? 'show-mobile-menu':''}`}>
            <button
              className={activeTab === "home" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("home");
                navigate("/");
                setShowMobileMenu(!showMobileMenu)
              }}
            >
              <Link className="link" to="/">Home</Link>
            </button>
            <button
              className={activeTab === "concept" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("concept");
                navigate("/concept");
                setShowMobileMenu(!showMobileMenu)
              }}
            >
              <Link className="link" to="/concept">
                Konzept
              </Link>
            </button>
            <button
              className={activeTab === "angebot" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("angebot");
                navigate("/angebot");
                setShowMobileMenu(!showMobileMenu)
              }}
            >
              <Link className="link" to="/angebot">
                Angebot
              </Link>
            </button>
            <button
              className={activeTab === "about" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("about");
                navigate("/about");
                setShowMobileMenu(!showMobileMenu);
              }}
            >
              <Link className="link" to="/about">
                Über uns
              </Link>
            </button>
            <button
              className={activeTab === "contact" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("contact");
                navigate("/contact");
                setShowMobileMenu(!showMobileMenu);
              }}
            >
              <Link className="link" to="/contact">
                Kontakt
              </Link>
            </button>
            <button
              className={activeTab === "contact" ? "tab active" : "tab"}
              onClick={() => {
                setActiveTab("gallery");
                navigate("/gallery");
                setShowMobileMenu(!showMobileMenu);
              }}
            >
              <Link className="link" to="/gallery">
                Gallerie
              </Link>
            </button>
          </div>
        </div>
      </header>
      ) : (
      <nav className="tabs">
        <button
          className={activeTab === "home" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("home");
            navigate("/");
          }}
        >
          <Link className="link" to="/">Home</Link>
        </button>
        <button
          className={activeTab === "concept" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("concept");
            navigate("/concept");
          }}
        >
          <Link className="link" to="/concept">
            Konzept
          </Link>
        </button>
        <button
          className={activeTab === "angebot" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("angebot");
            navigate("/angebot");
          }}
        >
          <Link className="link" to="/angebot">
            Angebot
          </Link>
        </button>
        <button
          className={activeTab === "about" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("about");
            navigate("/about");
          }}
        >
          <Link className="link" to="/about">
            Über uns
          </Link>
        </button>
        <button
          className={activeTab === "contact" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("contact");
            navigate("/contact");
          }}
        >
          <Link className="link" to="/contact">
            Kontakt
          </Link>
        </button>
        <button
          className={activeTab === "gallery" ? "tab active" : "tab"}
          onClick={() => {
            setActiveTab("gallery");
            navigate("/gallery");
          }}
        >
          <Link className="link" to="/gallery">
            Gallerie
          </Link>
        </button>
      </nav>
      ) }

      <Header className="header" />

      <main className="content">
        <Routes>
          <Route path="/" element={<HomeTab setActiveTab={setActiveTab} />} />
          <Route path="/concept" element={<KonzeptTab />} />
          <Route path="/angebot" element={<AngebotTab />} />
          <Route path="/about" element={<AboutTab />} />
          <Route path="/contact" element={<ContactTab />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function HomeTab({ setActiveTab }) {
  const navigate = useNavigate();
  return (
    <div className="home">
      <div className="home-grid">
        <div className="home-card">
          <img
            src={conceptImage}
            style={{ width: "30%", height: "auto", marginTop: "5%" }}
            alt="Konzept"
            className="home-img"
          />
          <h2>Konzept</h2>
          <p>
            Was ist Real Fruit Ice Cream?
          </p>
          <button
            className="home-button"
            onClick={() => {
              setActiveTab("concept");
              navigate("/concept");
              window.scrollTo(0, 0);
            }}
          >
            <Link className="link" to="/concept">
              Unser Konzept
            </Link>
          </button>
        </div>

        <div className="home-card">
          <img
            src={offerImage}
            style={{ width: "30%", height: "auto", marginTop: "5%" }}
            alt="Angebot"
            className="home-img"
          />
          <h2>Angebot</h2>
          <p>
            Sind wir der richtige Partner für deinen Event? 
          </p>
          <button
            className="home-button"
            onClick={() => {
              setActiveTab("angebot");
              navigate("/angebot");
              window.scrollTo(0, 0);
            } }
          >
            <Link className="link" to="/angebot">
              Angebot
            </Link>
          </button>
        </div>

        <div className="home-card">
          <img
            src={aboutImage}
            style={{ width: "30%", height: "auto", marginTop: "5%" }}
            alt="Über uns"
            className="home-img"
          />
          <h2>Über uns</h2>
          <p>
            Wer sind wir und wieso Real Fruit Ice Cream?
          </p>
          <button
            className="home-button"
            onClick={() => {
              setActiveTab("about");
              navigate("/about");
              window.scrollTo(0, 0);
            }}
          >
            <Link className="link" to="/about">
              Über uns
            </Link>
          </button>
        </div>

        <div className="home-card">
          <img
            src={contactImage}
            style={{ width: "30%", height: "auto", marginTop: "5%" }}
            alt="Kontakt"
            className="home-img"
          />
          <h2>Kontakt</h2>
          <p>
            Buche uns für deinen Event.
          </p>
          <button
            className="home-button"
            onClick={() => {
              setActiveTab("contact");
              navigate("/contact");
              window.scrollTo(0, 0);
            }}
          >
            <Link className="link" to="/contact">
              Kontakt
            </Link>
          </button>
        </div>
      </div>
     </div>
   );
}

function KonzeptTab() {
  return (
    <div className="konzept">
      <h2>Unser Konzept</h2>
      <h3>Wie funktioniert Real Fruit Ice Cream?</h3>
      
      <div className="konzept-div">
        <div className="konzept-inst"> 
          <div className="inst-top">
            <p><strong>Wähle deine Base</strong></p>
            <ul><li>Vanille Rahmglace</li>
            <li>Vanille Vegan</li></ul>
          </div>
          <div className="konzept-inst2">
            <p><strong>Wähle deine frische Zutat (Mischungen sind möglich)</strong></p>
            <ul>
              <li>Erdbeer</li>
              <li>Himbeer</li>
              <li>Kirsche</li>
              <li>Banane</li>
              <li>Heidelbeere</li>
              <li>Weitere Zutaten (auf Anfrage)</li>
              <li>Zusätzliche Kräuter, wie Pfefferminz oder Basilikum (auf Anfrage)</li>
            </ul>
          </div>
          <div className="inst-bottom">
            <p><strong>Daraus zwirbeln wir dir ein Real Fruit Ice Cream ins Cornet oder in den Becher</strong></p>
          </div>
        </div>
        <img
          src={flowImage}
          alt="Konzept"
          className="konzept-img"
        />
    </div>
    </div>
  );
}

function AngebotTab() {
  return (
    <div className="angebot">
      <h2>Unser Angebot</h2>
      <br />
      <h4>Kommt bei uns vorbei</h4>
      <p>
        An folgenden Märkten könnt ihr unseren Stand besuchen: 
      </p>
      <p style={{ fontSize: "16px" }}><i>13.06.2026</i> - Summer Opening Party <a href="https://www.vergani.ch/">Vergani</a> am Löwenplatz in Zürich</p>
      <br />
      <h4>Wir kommen bei dir vorbei</h4>
      <p>Gerne catern wir euren Event. Ob Hochzeit, Firmenfest oder Geburtstag. - Verfügbar ab 1. August 2026
        Wir kommen mit unserem Zwirbelglacewagen bei euch vorbei und kreieren vor Ort Real Fruit Ice Cream in den gewünschten Geschmacksrichtungen und servieren es direkt im Becher oder in der Waffel.
        Wählt einfach eure vier Lieblingsfrüchte aus der Liste unter "Konzept" oder fragt uns an bei Wünschen, die nicht auf der Liste stehen.
        Wir können euch viele Geschmäcker zusammenmischen, ihr könnt also auch selber kreativ werden. 
      </p>
      <p><strong>Bitte beachte:</strong> <br />
        Jedes Glace wird individuell zusammengemischt. Zwischen den Portionen kann die Maschine nur rudimentär gereinigt werden.
        Es kann vorkommen, dass noch ein Rest vom vorangehenden Glace merklich ist. 
        Für Allergiker ist wichtig zu wissen, dass es zu Kreuzkontaminationen kommen kann. Bitte beachtet dies bei der Auswahl der Geschmäcker.
        Unser Glacewagen ist handgeschoben und schwer. Wir bringen ihn mit dem Auto zu eurer Location, können aber vom Parkplatz aus keine Stufen überwinden.
      </p>
      <br />
      <h4>Was kostet ein Catering?</h4>
      <p>Gerne erstellen wir dir auf Anfrage eine individuelle Offerte. Die folgenden Beispiele geben dir
        ein paar Richtpreise als Orientierung.
      </p>
      <table style={ { borderCollapse: "collapse", width: "100%", marginTop: "20px" } }>
        <tr>
          <th style={ { textAlign: "left" } }>Anzahl Personen</th>
          <td>100</td>
          <td>50</td>
          <td>50</td>
        </tr>
        <tr>
          <th style={ { textAlign: "left" } }>Dauer des Events</th>
          <td>3 h</td>
          <td>3 h</td>
          <td>1.5 h</td>
        </tr>
        <tr>
          <th style={ { textAlign: "left" } }>Ungefährer Standort</th>
          <td>Stadt Zürich</td>
          <td>Stadt Zürich</td>
          <td>Stadt Zürich</td>
        </tr>
        <tr style={ { borderTop: "1px solid black" } }>
          <th style={ { textAlign: "left" } }>Preis</th>
          <td>1290 CHF</td>
          <td>800 CHF</td>
          <td>720 CHF</td>
        </tr>
      </table>
    </div>
  );
}

function AboutTab() {
  return (
  <div>
    <h2 style={ { textAlign: "left", paddingTop: "10%", paddingBottom: "2%", paddingLeft: "10%", paddingRight: "10%" } }>Wer sind wir</h2>
    <div className="about-container">
      <img
              src={aboutUsImage}
              alt="Über uns"
              className="aboutus-img"
            />
      <div className="about">
        <br />
        <p>Wir sind Angela Jenny und Quinten Jenny.
          Zusammen sind wir ein kleines zwei-Personen Unternehmen. 
          Mit unserem mobilen, handgeschobenen Glacewagen möchten wir 
          neuseeländisches Real Fruit Ice Cream in der Schweiz bekannt und beliebt machen.
        </p>
        <h4>Wieso Real Fruit Ice Cream?</h4>
        <p>
          Auf einer dreimonatigen Reise durch Neuseeland haben wir Real Fruit Ice Cream für uns entdeckt. 
          In Neuseeland gibt es das klassisch gezwirbelte Soft Ice aus frisch gefrorenen Früchten und 
          Vanilleglace in fast jedem Dorf und an jedem Markt. 
        </p>
        <p>
          Da wir unser tägliches Real Fruit Ice Cream in der Schweiz schmerzlich vermissten und sich das 
          Angebot hier als äusserst karg herausstellte, sahen wir uns vor die Wahl gestellt: Würden wir 
          eine hardcore  Real Fruit Ice Cream Diät halten, und sparen um nach einem 24-Stundenflug 
          irgendwann in unserem Leben wieder einmal dieses Glace geniessen zu können, oder würden wir 
          die Verbreitung des gezwirbelten Gaumenschmauses in der Schweiz selber angehen. 
        </p>
        <p>
          Wir nahmen die Herausforderung an und bestellten unsere eigene Trendyblends Real Fruit Ice Cream 
          Maschine. Das Zwirbeln übten wir bis zur (naja beinahe) Perfektion. Und nun sind wir bereit, 
          das Glace mit euch zu teilen. 
        </p>
        <p>
          Sowohl für Real Fruit Ice Cream Neulinge, die aus Neugier unser Glace probieren wollen, 
          als auch für andere Neuseeland-Heimkehrer mit Lust auf ein bisschen Heimweh sind wir gerne da und 
          zwirbeln euch eure Lieblingsfrüchte und Beeren in eine süsse Vanillebase. 
        </p>
      </div>
    </div>
  </div>
  );
}

function ContactTab() {
  return (
    <div className="contact">
      <h2>Kontakt</h2>
      <br />
      <p>
        Gerne Catern wir euren Event. Ob Hochzeit, Firmenfest oder Geburtstag. 
        Kontaktiert uns per Mail für eine unverbindliche Offerte. Dafür brauchen 
        wir folgende Informationen: 
      </p>
      <ul>
        <li>Datum</li>
        <li>Uhrzeit (von wann bis wann sollen wir vor Ort sein)</li>
        <li>Standort</li>
        <li>Anzahl Personen</li>
        <li>Welche Zutaten sind gewünscht (maximal 4 verschiedene)</li>
        <ul>
          <li>
            Vanille Rahmglace
          </li>
          <li>
            Vanille Veganes Glace
          </li>
          <li>
            Erdbeere
          </li>
          <li>
            Himbeere
          </li>
          <li>
            Heidelbeere
          </li>
          <li>
            Kirsche
          </li>
          <li>
            Banane
          </li>
          <li>
            Mango
          </li>
        </ul>
        <li>
          Auf Anfrage können auch andere Geschmäcker geliefert werden. 
          Schreibt uns eure Wünsche und wir schauen, ob es machbar ist. 
        </li>
        <li>
          Bitte beachtet, dass die Maschine zwischen zwei Portionen nur 
          rudimentär gereinigt werden kann. Bei Allergenen kann es zu 
          Kreuzkontaminationen kommen.
        </li>
      </ul>
      <br />
      <p>Kontaktiere uns um eine unverbindliche Offerte für dein Event zu erhalten. </p>
      <br />
      <p>
         Mail: <a href="mailto:zwirbelglace@bluewin.ch">zwirbelglace@bluewin.ch</a>
      </p>
    </div>
  );
}

function Gallery() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery">
            <LightGallery
                elementClassNames={'gallerymedia'}
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom]}
                download={false}
            >
                <a href={aboutUsImage}>
                    <img className="thumbnail_wide" alt="img1" src={aboutUsImage} />
                </a>
                <a href={galleryImage4}>
                    <img className="thumbnail_wide" alt="img5" src={galleryImage4} />
                </a>
                <a href={galleryImage1}>
                    <img className="thumbnail" alt="img2" src={galleryImage1} />
                </a>
                <a href={galleryImage2}>
                    <img className="thumbnail" alt="img3" src={galleryImage2} />
                </a>
                <a href={galleryImage3}>
                    <img className="thumbnail" alt="img4" src={galleryImage3} />
                </a>
                <a href={galleryImage5}>
                    <img className="thumbnail" alt="img6" src={galleryImage5} />
                </a>
                <a href={galleryImage6}>
                    <img className="thumbnail" alt="img7" src={galleryImage6} />
                </a>
                <a href={galleryImage7}>
                    <img className="thumbnail" alt="img8" src={galleryImage7} />
                </a>
            </LightGallery>
        </div>
    );
}

export default App;